<div class="cx-order-summary">
  <div class="container" *ngIf="order?.engineReplacementAttestation">
    <div *ngIf="order?.engineReplacementAttestation?.engineModelNumber"
      class="cx-review-summary gen-engine-replacement-review row">
      <div class="cx-summary-card">
        <ng-container *ngTemplateOutlet="engineReplacementReviewCard; context: {
            content$: getEngineReplacementModelNumberCard(order?.engineReplacementAttestation?.engineModelNumber),
          }">
        </ng-container>

        <ng-container *ngTemplateOutlet="engineReplacementReviewCard; context: {
            content$: getEngineReplacementAccountIdCard(order?.engineReplacementAttestation?.dealerId),
          }">
        </ng-container>

        <ng-container *ngTemplateOutlet="engineReplacementReviewCard; context: {
            content$: getEngineReplacementPurchaseDateCard(order?.engineReplacementAttestation?.purchaseDate),
          }">
        </ng-container>
      </div>

      <div class="cx-summary-card">
        <ng-container *ngTemplateOutlet="engineReplacementReviewCard; context: {
            content$: getEngineReplacementSerialNumberCard(order?.engineReplacementAttestation?.engineSerialNumber),
          }">
        </ng-container>

        <ng-container *ngTemplateOutlet="engineReplacementReviewCard; context: {
            content$: getEngineReplacementPurchasingUserCard(order?.engineReplacementAttestation?.purchasingUser),
          }">
        </ng-container>

        <ng-container *ngTemplateOutlet="engineReplacementReviewCard; context: {
            content$: getEngineReplacementAttestationCheckboxesCard(order?.engineReplacementAttestation?.replacementReason),
          }">
        </ng-container>
      </div>

      <div class="cx-summary-card">
        <ng-container *ngTemplateOutlet="engineReplacementReviewCard; context: {
            content$: getEngineReplacementDestroyedByCard(order?.engineReplacementAttestation),
          }">
        </ng-container>
      </div>
    </div>

    <ng-template #engineReplacementReviewCard let-content$="content$">
      <cx-card [content]="content$ | async"></cx-card>
    </ng-template>
  </div>
</div>